import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class Banner {
    constructor() {
        this.init();
    }

    init() {
        this.bnrSwiper();
    }

    bnrSwiper() {
        const option = {
            autoplay: { delay: 5000 },
            loop: true,
            pagination: { el: ".swiper-pagination", clickable: true },
        };

        const swiper = new Swiper(".information__banner__slide", option);
    }
}
